import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

class Profile extends Component {
    render() {
        // Redirect to business profile page since profile page is not implemented
        return <Redirect to="/home/business-profile" />;
    }
}

export default Profile;
